import UIListener from '@/UIListener/UIListener';
import ComponentManager from '@/Management/ComponentManager';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import DeletedUsersFactory from '@/Factories/ControlFactories/DeletedUsersFactory';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import ToolbarHelper from '@/Utility/ToolbarHelper';

export default class UserRecycleBinUIListener extends UIListener {

    constructor() {
        super();
    }

    public onBeforeRender(context: DetailViewContext) {
        this.removeDetailViewGroupDto(context, context.getConcretePdTypeName() + '.METADATA');
    }

    public onDetailViewReady(context: DetailViewContext): void {

        ToolbarHelper.removeSaveButton(context.toolBar, false);
        ToolbarHelper.removeApplyButton(context.toolBar);

        context.toolBar.primaryLinks[0].label.ergName('CLOSE');

        let deletedUsers = context.getUIFactory<DeletedUsersFactory>('UserControlPlaceHolder').viewModel;

        if (deletedUsers != null) {
            context.toolBar.addPrimaryElement({
                position: 0,
                ergName: deletedUsers.restoreText,
                onClick: deletedUsers.restore,
                iconUrl: GlobalConfiguration.inlineImages.USER_RECYCLE,
                locator: 'restore',
                tooltipErgName: deletedUsers.restoreTooltipText,
                isEnabled: this.defineComputed(() => {
                    return deletedUsers.grid.selected().length > 0;
                })
            });
        }
    }
}

ComponentManager.setUIListener('UserRecycleBinUIListener', UserRecycleBinUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.UserRecycleBinUIListener', UserRecycleBinUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');